import type { useTranslations } from 'next-intl';
import { ChannelAnimation } from '@/app/components/icons/ChannelAnimation';
import { ChannelCycle } from '@/app/components/icons/ChannelCycle';
import { ChannelLightning } from '@/app/components/icons/ChannelLightning';
import { SITE } from '@/app/constants';

export const URL_CONFIG_CHINA = [
  {
    id: 'chinaWhyVidu1',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner5-f5f8e907.webp',
  },
  {
    id: 'chinaWhyVidu2',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner4-7a1e979b.webp',
  },
  {
    id: 'chinaWhyVidu3',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner3-3b5b55f3.webp',
  },
  {
    id: 'chinaWhyVidu4',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner2-9da68e3f.webp',
  },
  {
    id: 'chinaWhyVidu5',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner1-3b82d2a0.webp',
  },
  {
    id: 'chinaWhyVidu6',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability1-f6937f83.webp',
  },
  {
    id: 'chinaWhyVidu7',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability2-ce0109cb.webp',
  },
  {
    id: 'chinaWhyVidu8',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability3-fae52eca.webp',
  },
  {
    id: 'chinaWhyVidu9',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage1-074b6370.webp',
  },
  {
    id: 'chinaWhyVidu10',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage2-8e3428b7.webp',
  },
  {
    id: 'chinaWhyVidu11',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage3-a84f9662.webp',
  },
  {
    id: 'chinaWhyVidu12',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene2-518d3dc6.webp',
  },
  {
    id: 'chinaWhyVidu13',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene3-fb9738c9.webp',
  },
  {
    id: 'chinaWhyVidu14',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene1-e6f2db5c.webp',
  },
  {
    id: 'chinaWhyVidu15',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner5-f5f8e907.webp',
  },
  {
    id: 'chinaWhyVidu16',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner4-7a1e979b.webp',
  },
  {
    id: 'chinaWhyVidu17',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner3-3b5b55f3.webp',
  },
  {
    id: 'chinaWhyVidu18',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner2-9da68e3f.webp',
  },
  {
    id: 'chinaWhyVidu19',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner1-3b82d2a0.webp',
  },
  {
    id: 'chinaWhyVidu20',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability1-f6937f83.webp',
  },
  {
    id: 'chinaWhyVidu21',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability2-ce0109cb.webp',
  },
  {
    id: 'chinaWhyVidu22',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability3-fae52eca.webp',
  },
  {
    id: 'chinaWhyVidu23',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage1-074b6370.webp',
  },
  {
    id: 'chinaWhyVidu24',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage2-8e3428b7.webp',
  },
  {
    id: 'chinaWhyVidu25',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage3-a84f9662.webp',
  },
  {
    id: 'chinaWhyVidu26',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene2-518d3dc6.webp',
  },
  {
    id: 'chinaWhyVidu27',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene3-fb9738c9.webp',
  },
  {
    id: 'chinaWhyVidu28',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene1-e6f2db5c.webp',
  },
  {
    id: 'chinaWhyVidu29',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner5-f5f8e907.webp',
  },
  {
    id: 'chinaWhyVidu30',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner4-7a1e979b.webp',
  },
  {
    id: 'chinaWhyVidu31',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner3-3b5b55f3.webp',
  },
  {
    id: 'chinaWhyVidu32',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner2-9da68e3f.webp',
  },
  {
    id: 'chinaWhyVidu33',
    url: 'https://image01.vidu.zone/vidu/media-asset/banner1-3b82d2a0.webp',
  },
  {
    id: 'chinaWhyVidu34',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability1-f6937f83.webp',
  },
  {
    id: 'chinaWhyVidu35',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability2-ce0109cb.webp',
  },
  {
    id: 'chinaWhyVidu36',
    url: 'https://image01.vidu.zone/vidu/media-asset/ability3-fae52eca.webp',
  },
  {
    id: 'chinaWhyVidu37',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage1-074b6370.webp',
  },
  {
    id: 'chinaWhyVidu38',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage2-8e3428b7.webp',
  },
  {
    id: 'chinaWhyVidu39',
    url: 'https://image01.vidu.zone/vidu/media-asset/advantage3-a84f9662.webp',
  },
  {
    id: 'chinaWhyVidu40',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene2-518d3dc6.webp',
  },
  {
    id: 'chinaWhyVidu41',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene3-fb9738c9.webp',
  },
  {
    id: 'chinaWhyVidu42',
    url: 'https://image01.vidu.zone/vidu/media-asset/scene1-e6f2db5c.webp',
  },
];
export const URL_CONFIG_GLOBAL = [
  {
    id: 'globalWhyVidu1',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner2-475f6572.webp',
  },
  {
    id: 'globalWhyVidu2',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner1-3b82d2a0.webp',
  },
  {
    id: 'globalWhyVidu3',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner5-da9a12cd.webp',
  },
  {
    id: 'globalWhyVidu4',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability1-a069c598.webp',
  },
  {
    id: 'globalWhyVidu5',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability2-2b4b27f3.webp',
  },
  {
    id: 'globalWhyVidu6',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability3-205cb51b.webp',
  },
  {
    id: 'globalWhyVidu7',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage1-b72397f4.webp',
  },
  {
    id: 'globalWhyVidu8',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage2-d513cd5c.webp',
  },
  {
    id: 'globalWhyVidu9',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage3-818b9c52.webp',
  },
  {
    id: 'globalWhyVidu10',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene1-81572fce.webp',
  },
  {
    id: 'globalWhyVidu11',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene3-bc6635ad.webp',
  },
  {
    id: 'globalWhyVidu12',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene2-2cde166f.webp',
  },
  {
    id: 'globalWhyVidu13',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/last-935b4a6c.webp',
  },
  {
    id: 'globalWhyVidu14',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner2-475f6572.webp',
  },
  {
    id: 'globalWhyVidu15',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner1-3b82d2a0.webp',
  },
  {
    id: 'globalWhyVidu16',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner5-da9a12cd.webp',
  },
  {
    id: 'globalWhyVidu17',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability1-a069c598.webp',
  },
  {
    id: 'globalWhyVidu18',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability2-2b4b27f3.webp',
  },
  {
    id: 'globalWhyVidu19',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability3-205cb51b.webp',
  },
  {
    id: 'globalWhyVidu20',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage1-b72397f4.webp',
  },
  {
    id: 'globalWhyVidu21',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage2-d513cd5c.webp',
  },
  {
    id: 'globalWhyVidu22',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage3-818b9c52.webp',
  },
  {
    id: 'globalWhyVidu23',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene1-81572fce.webp',
  },
  {
    id: 'globalWhyVidu24',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene3-bc6635ad.webp',
  },
  {
    id: 'globalWhyVidu25',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene2-2cde166f.webp',
  },
  {
    id: 'globalWhyVidu26',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/last-935b4a6c.webp',
  },
  {
    id: 'globalWhyVidu27',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner2-475f6572.webp',
  },
  {
    id: 'globalWhyVidu28',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner1-3b82d2a0.webp',
  },
  {
    id: 'globalWhyVidu29',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/banner5-da9a12cd.webp',
  },
  {
    id: 'globalWhyVidu30',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability1-a069c598.webp',
  },
  {
    id: 'globalWhyVidu31',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability2-2b4b27f3.webp',
  },
  {
    id: 'globalWhyVidu32',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/ability3-205cb51b.webp',
  },
  {
    id: 'globalWhyVidu33',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage1-b72397f4.webp',
  },
  {
    id: 'globalWhyVidu34',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage2-d513cd5c.webp',
  },
  {
    id: 'globalWhyVidu35',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/advantage3-818b9c52.webp',
  },
  {
    id: 'globalWhyVidu36',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene1-81572fce.webp',
  },
  {
    id: 'globalWhyVidu37',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene3-bc6635ad.webp',
  },
  {
    id: 'globalWhyVidu38',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/scene2-2cde166f.webp',
  },
  {
    id: 'globalWhyVidu39',
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/last-935b4a6c.webp',
  },
];

export const URL_CONFIG = SITE === 'global' ? URL_CONFIG_GLOBAL : URL_CONFIG_CHINA;

export const WHY_VIDU_CONFIG = (t: ReturnType<typeof useTranslations>) => [
  {
    icon: ChannelLightning,
    key: 'instant',
    title: t('instant'),
    info: t('creation'),
    description: t('instantDesc'),
  },
  {
    icon: ChannelAnimation,
    key: 'superiorAnime',
    title: t('superiorAnime'),
    info: t('generation'),
    description: t('generationDesc'),
  },
  {
    icon: ChannelCycle,
    key: 'unlimitedFree',
    title: t('unlimitedFree'),
    info: t('credits'),
    description: t('creditsDesc'),
  },
];
